"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CompareArrows_exports = {};
__export(CompareArrows_exports, {
  default: () => CompareArrows_default
});
module.exports = __toCommonJS(CompareArrows_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.78125 12.0273L7.29688 10.6406C7.15365 10.4974 7.08203 10.3281 7.08203 10.1328C7.08203 9.9375 7.15365 9.76823 7.29688 9.625C7.4401 9.48177 7.60938 9.41016 7.80469 9.41016C8.01302 9.41016 8.1888 9.48177 8.33203 9.625L11.1055 12.2422C11.1706 12.3073 11.2227 12.3854 11.2617 12.4766C11.3138 12.5547 11.3398 12.6458 11.3398 12.75C11.3398 12.8542 11.3138 12.9518 11.2617 13.043C11.2227 13.1211 11.1706 13.1927 11.1055 13.2578L8.33203 15.875C8.1888 16.0182 8.01302 16.0898 7.80469 16.0898C7.60938 16.0898 7.4401 16.0182 7.29688 15.875C7.15365 15.7318 7.08203 15.5625 7.08203 15.3672C7.08203 15.1719 7.15365 15.0026 7.29688 14.8594L8.78125 13.4727H2.90234C2.70703 13.4727 2.53125 13.401 2.375 13.2578C2.23177 13.1146 2.16016 12.9453 2.16016 12.75C2.16016 12.5547 2.23177 12.3854 2.375 12.2422C2.53125 12.099 2.70703 12.0273 2.90234 12.0273H8.78125ZM12.2188 8.47266L13.7031 9.85938C13.8464 10.0026 13.918 10.1719 13.918 10.3672C13.918 10.5625 13.8464 10.7318 13.7031 10.875C13.5599 11.0182 13.3841 11.0898 13.1758 11.0898C12.9805 11.0898 12.8112 11.0182 12.668 10.875L9.89453 8.25781C9.82943 8.19271 9.77083 8.12109 9.71875 8.04297C9.67969 7.95182 9.66016 7.85417 9.66016 7.75C9.66016 7.64583 9.67969 7.55469 9.71875 7.47656C9.77083 7.38542 9.82943 7.30729 9.89453 7.24219L12.668 4.625C12.8112 4.48177 12.9805 4.41016 13.1758 4.41016C13.3841 4.41016 13.5599 4.48177 13.7031 4.625C13.8464 4.76823 13.918 4.9375 13.918 5.13281C13.918 5.32812 13.8464 5.4974 13.7031 5.64062L12.2188 7.02734H18.0977C18.293 7.02734 18.4622 7.09896 18.6055 7.24219C18.7617 7.38542 18.8398 7.55469 18.8398 7.75C18.8398 7.94531 18.7617 8.11458 18.6055 8.25781C18.4622 8.40104 18.293 8.47266 18.0977 8.47266H12.2188Z",
      fill: "currentColor"
    }
  )
);
const SvgCompareArrows = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CompareArrows_default = SvgCompareArrows;
